import * as React from 'react';
/**
 *
 * Original name: h2
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=1%3A163
 *
 */
export const H2Line = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M18.7 16.669c1.431-.424 2.476-.928 2.476-2.197 0-1.162-.838-2.017-2.719-2.017-2 0-3.016.864-3.016 2.404v.162h1.342v-.126c0-.855.55-1.323 1.647-1.323.954 0 1.405.324 1.405.936 0 .65-.793.918-1.89 1.25-1.35.405-2.594.864-2.594 2.305V19h5.78v-1.198h-4.285c.054-.549.72-.791 1.854-1.133ZM12 11.5H4.5v-6H3V19h1.5v-6H12v6h1.5V5.5H12v6Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
